export default "__VITE_ASSET__BqfgI9If__"